const Tooltip = {
  styleOverrides: {
    tooltip: ({ ownerState, theme }) => ({
      color: theme.palette.custom.text,
      backgroundColor: theme.palette.custom.stroke,
    }),
    arrow: ({ ownerState, theme }) => ({
      color: theme.palette.custom.stroke,
    }),
  },
};

export default Tooltip;
